<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";

export default {
  name: "PoleMaterialFields",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Array | Object,
      required: true
    },

    editingData: {
      type: Boolean,
      required: true,
    }
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    }
  },

  computed: {
    /**
     * @return {Array} - the different pole type options
     */
    poleTypeOptions() {
      return this.$store.getters.optionLists_poleType;
    },
    /**
     * @return {Array} - the different height type options
     */
    heightOptions() {
      return this.$store.getters.optionLists_poleHeight;
    },
    /**
     * @return {Array} - the different class type options
     */
    classOptions() {
      return this.$store.getters.optionLists_poleClass;
    },

    fields() {
      return [
        {
          label: this.$i18n.tc("Pole", 1) + ' ' + this.$i18n.tc("Type", 1),
          value: !this.editingData
            ? this.parseSelectValue([this.familySpecificFields.smpl_pole_type], this.poleTypeOptions)
            : this.familySpecificFields.smpl_pole_type,
          varName: 'smpl_pole_type',
          inputType: 'select',
          disabled: false,
          required: true,
          options: this.poleTypeOptions,
          clearable: true,
          size: '100%'
        },
        {
          label: this.$i18n.t("Height"),
          value: !this.editingData
            ? this.parseSelectValue([this.familySpecificFields.smpl_height], this.heightOptions)
            : this.familySpecificFields.smpl_height,
          varName: 'smpl_height',
          inputType: 'select',
          disabled: false,
          required: true,
          options: this.heightOptions,
          clearable: true,
          size: '100%'
        },
        {
          label: this.$i18n.t("Class"),
          value: !this.editingData
            ? this.parseSelectValue([this.familySpecificFields.smpl_class], this.classOptions)
            : this.familySpecificFields.smpl_class,
          varName: 'smpl_class',
          inputType: 'select',
          disabled: false,
          options: this.classOptions,
          clearable: true,
          size: '100%'
        },
      ]
    },
  },

  methods: {
    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return (
        !!this.familySpecificFields.smpl_pole_type &&
        this.familySpecificFields.smpl_pole_type.length > 0 &&
        !!this.familySpecificFields.smpl_height
      );
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsPole.vue